/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { getUniqueYearTermPairs } from '../../../../../utils/utils'

export const fetchTeachingSchedule = createAsyncThunk(
  'fetchTeachingSchedule',
  async () => {
    const jwtToken = localStorage.getItem('myrJwtToken')
    const rcpid = localStorage.getItem('rcpid')
    const res = await axios.get(
      `${process.env.REACT_APP_MYTEACHINGSCHEDULE_ENDPOINT}?includeNextTerm=true`,
      {
        headers: {
          JWT: jwtToken,
          XWT: rcpid,
        },
      },
    )
    return res.data
  },
)

const initialState = {
  status: 'idle',
  tab: 'ru',
  currentTerm: 0,
  courseTerms: [],
  data: {
    title: 'My Teaching Schedule',
  },
}

const MyTeachingScheduleSlice = createSlice({
  name: 'myTeachingSchedule',
  initialState,
  reducers: {
    updateCurrentTerm: (state, action) => {
      state.currentTerm = action.payload
    },
  },
  extraReducers: {
    [fetchTeachingSchedule.rejected]: (state) => {
      state.status = 'error'
    },
    [fetchTeachingSchedule.pending]: (state) => {
      state.status = 'pending'
    },
    [fetchTeachingSchedule.fulfilled]: (state, action) => {
      state.status = 'fulfilled'
      const defaultTab = action.payload?.rbhs?.length > 0 ? 'rbhs' : 'ru'
      state.tab = defaultTab
      state.courseTerms = getUniqueYearTermPairs(action.payload[defaultTab])
      state.data = action.payload
    },
  },
})

export const selectTeachingScheduleData = (state) =>
  state.myTeachingSchedule.data
export const selectTeachingScheduleStatus = (state) =>
  state.myTeachingSchedule.status
export const selectTeachingScheduleCourseTerms = (state) =>
  state.myTeachingSchedule.courseTerms
export const selectTeachingScheduleCurrentTerm = (state) =>
  state.myTeachingSchedule.currentTerm

export const { updateCurrentTerm } = MyTeachingScheduleSlice.actions

export default MyTeachingScheduleSlice.reducer
